<script>
  export let size = 34;
  export let className;
  export let firstName = '';
  export let lastName = '';
  export let photoUrl = '';
  const validString = (textValue) => !!textValue?.trim?.()?.length;
  function getUserLabel() {
    let text = '';
    if (validString(firstName)) {
      text += firstName.toString().substr(0, 1).toUpperCase();
    }
    if (validString(lastName)) {
      text += lastName.toString().substr(0, 1).toUpperCase();
    }
    return text;
  }
  let fontSize = Math.floor(size / 2) - 1;
</script>

<div
  class="nav-profile-img {className}"
  style="width: {size}px; height: {size}px; "
>
  {#if validString(photoUrl)}
    <div
      style="width: {size}px; height: {size}px;background-position:
	  center;       background-size: cover; background-repeat: no-repeat;background-image:url({photoUrl})"
      class="userProfileImg rounded-circle statusActive cursor"
    />
  {:else if validString(firstName) && validString(lastName)}
    <div
      style="width: {size}px; height: {size}px;"
      class="userProfileImg rounded-circle statusActive cursor"
    >
      <div
        class="d-flex align-items-center justify-content-center"
        style="width:{size}px; height:{size}px; background-color:#206bc4; color:#fff; border-radius:50%; font-weight:400; font-size:{size /
          2.5}px"
      >
        {getUserLabel()}
      </div>
    </div>
  {/if}
</div>

<style lang="scss">
  .nav-profile-img {
    position: relative;
  }
  .user-online {
    width: 8px;
    height: 8px;
    position: absolute;
    right: 0px;
    bottom: 0px;
    z-index: 1;
  }

  .img-small {
    width: 15px;
    height: 15px;
  }
</style>
